import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop, usePersonalDetails } from 'Hooks';
import { BlackCake } from 'Images';

export const Title = () => {
  const personalDetails = usePersonalDetails();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Home);
  const isDesktop = useIsDesktop();

  /* TODO update when api updates birthday details */
  const isBirthday = false;

  return (
    <Stack gap={isDesktop ? '' : '16px'}>
      <Typography variant='body1' component={'h1'}>
        {dictionary.helloName(personalDetails?.firstName || '')}
      </Typography>
      {isBirthday && !isDesktop && (
        <Stack mt={'-12px'} direction={'row'} gap={'8px'}>
          <Avatar
            src={BlackCake}
            alt=''
            sx={{
              width: '24px',
              height: '24px',
            }}
          />
          <Typography variant='body2' component={'h1'}>
            {Dictionary[DICTIONARY.Home].birthdaySubtitle}
          </Typography>
        </Stack>
      )}
      <Typography variant='body2'>
        {Dictionary[DICTIONARY.Home].subtitle}
      </Typography>
    </Stack>
  );
};
